import { type CountryCode, getCountryCallingCode, getExampleNumber } from 'libphonenumber-js';
import mobileExamples from 'libphonenumber-js/mobile/examples';

export function getPhoneNumberPlaceholder(countryCode?: CountryCode): string | undefined {
	if (!countryCode) return undefined;

	const callingCode = `+${getCountryCallingCode(countryCode)}`;
	const exampleNumber = getExampleNumber(countryCode, mobileExamples);
	if (!exampleNumber) return callingCode;

	const nationalNumberPlaceholder = exampleNumber.formatInternational().slice(callingCode.length).replace(/\d/g, 'X');
	return `${callingCode}${nationalNumberPlaceholder}`;
}
